import React, { useState, useEffect } from "react";

const BarGraphs: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [questions, setQuestions] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    const objects = [
        "Apples", "Bananas", "Grapes", "Oranges", "Pencils", "Books", "Cars", "Balls", "Chocolates",
        "Bottles", "Notebooks", "Pens", "Shoes", "Toys", "Mugs", "Cups", "Chairs", "Tables", "Laptops",
        "Phones", "TV Sets", "Bags", "Hats", "Pizzas", "Cookies", "T-Shirts", "Jackets", "Socks", "Blankets",
        "Gloves", "Plates", "Spoons", "Forks", "Knives", "Towels", "Rulers", "Erasers", "Markers", "Stamps",
        "Backpacks", "Umbrellas", "Ice Creams", "Sandwiches", "Waffles", "Donuts", "Mice", "Keyboards",
        "Bicycles", "Trains", "Airplanes", "Tractors", "Blocks", "Stickers",
        "Flowers", "Trees", "Leaves", "Seeds", "Birds", "Fish", "Animals", "Stars", "Clouds",
        "Sunflowers", "Cars", "Trucks", "Buses", "Motorcycles", "Teddies", "Lollipops", "Light Bulbs", "Paints",
        "Paint Brushes", "Puzzles", "Tickets", "Cupcakes", "Candies", "Fruits", "Vegetables", "Spices", "Grains",
        "Nuts", "Flowers", "Trees", "Flags", "Maps", "Pictures", "Plants", "Parrots", "Snakes", "Rabbits"
        , "Jelly Beans", "Cans"
    ];

    // Generate unique random data for the bar graph
    const generateBarGraphData = () => {
        const selectedObjects = [];
        const usedIndices = new Set<number>();
        const usedQuantities = new Set<number>();

        while (selectedObjects.length < 4) {
            const randomIndex = Math.floor(Math.random() * objects.length);
            const quantity = Math.floor(Math.random() * 10) + 1; // Quantity between 1 and 10

            if (
                !usedIndices.has(randomIndex) && // Ensure unique objects
                !usedQuantities.has(quantity) // Ensure unique quantities
            ) {
                const randomObject = objects[randomIndex];
                selectedObjects.push({ object: randomObject, quantity });
                usedIndices.add(randomIndex);
                usedQuantities.add(quantity);
            }
        }
        return selectedObjects;
    };

    // Generate dynamic questions based on the bar graph data
    const generateQuestions = (barGraphData: any[]) => {
        const total = barGraphData.reduce((acc, item) => acc + item.quantity, 0);

        const questionSet = [
            {
                question: `How many ${barGraphData[0].object} are there?`,
                answer: barGraphData[0].quantity,
            },
            {
                question: `How many ${barGraphData[1].object} are there?`,
                answer: barGraphData[1].quantity,
            },
            {
                question: `Which object has the highest quantity?`,
                answer: barGraphData.reduce((max, item) =>
                    item.quantity > max.quantity ? item : max
                ).object,
            },
            {
                question: `What is the total number of objects represented?`,
                answer: total,
            },
        ];

        return questionSet;
    };

    useEffect(() => {
        handleQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Data Handling - Bar Graphs"; // Set page title
    }, []);

    const handleQuestion = () => {
        const newData = generateBarGraphData();
        setData(newData);
        setQuestions(generateQuestions(newData));
        setCurrentQuestionIndex(Math.floor(Math.random() * 3) + 1);
    };


    const handleAnswerSubmit = (userAnswer: any) => {
        setSelectedOption(userAnswer);
        const correctAnswer = questions[currentQuestionIndex].answer;
        if (userAnswer === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                handleQuestion();
                setShowImage(false);
            }, 5000);
        } else {
            setShowImage(false);
        }
    };

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter additionWord">
                        <div className="mb-4" style={{ width: '100%' }}>
                            {data.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <span style={{ width: "30%" }}>{item.object}</span>
                                    <div style={{ width: "70%" }}>
                                        <div
                                            style={{
                                                height: "20px",
                                                backgroundColor: "blue",
                                                width: `${item.quantity * 15}px`,
                                                marginLeft: "10px",
                                                display: "inline-block"
                                            }}
                                        />
                                        <span style={{ marginLeft: "10px" }}>{item.quantity}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div>
                            <h3>Question:</h3>
                            <p>{questions[currentQuestionIndex]?.question}</p>
                        </div>
                        <div className=" bargraph" style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {typeof questions[currentQuestionIndex]?.answer === "number" ? (
                                [questions[currentQuestionIndex].answer - 1, questions[currentQuestionIndex].answer, questions[currentQuestionIndex].answer + 1]
                                    .sort(() => Math.random() - 0.5) // Shuffle options
                                    .map((option, index) => (
                                        <div style={{ padding: '0 15px' }}
                                            className={`background-blue ${selectedOption === option
                                                    ? option === questions[currentQuestionIndex].answer
                                                        ? 'correct'
                                                        : 'incorrect'
                                                    : ''
                                                }`}
                                            key={index}
                                            onClick={() => handleAnswerSubmit(option)}
                                        >
                                            {option}
                                        </div>
                                    ))
                            ) : (
                                data.map((item, index) => (
                                    <div style={{ padding: '0 15px' }}
                                        className={`background-blue ${selectedOption === item.object
                                                ? item.object === questions[currentQuestionIndex].answer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                            }`}
                                        key={index}
                                        onClick={() => handleAnswerSubmit(item.object)}
                                    >
                                        {item.object}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: '150px' }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                            alt="Well Done"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default BarGraphs;
